import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';

export default function Intro({ children, background, onClick, withCongrats, withBee, size }) {
  const classes = classNames({
    [styles.intro]: true,
    'c-pointer': Boolean(onClick),
    [styles[size]]: Boolean(size)
  });

  return (
    <div className={classes} onClick={onClick}>
      {withBee && <img src={withBee} className={styles.bee} alt='' />}
      <img src={background} className={styles.background} alt='' />
      {withCongrats && <img src={withCongrats} className={styles.congrats} alt='' />}
      <div className={styles.content}>{children}</div>
    </div>
  );
}

Intro.propTypes = {
  background: PropTypes.string,
  withCongrats: PropTypes.string,
  withBee: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['middle'])
};
